import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';
import { grooveUserMetadata, isLiteGrooveUser } from '../../shared/bootstrap-failure.mjs';

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState(['lang'])
  }
});

export default new Vuex.Store({
  ...core,
  modules: {
    core,
    records,
    domains,
    subdomains,
  },
  state: {},
  getters: {
    user: state => state.user,
    isLiteUser: state => isLiteGrooveUser(state.user),
    metaData: state => grooveUserMetadata(state.user),
  }
});
